import { useEffect } from 'react'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

// Programmatic play after visibility changes is not always allowed (autoplay policy,Low Power Mode)
function tryPlayVideo(video) {
  if (!video) return

  const handlePlayError = (error) => {
    if (error?.name === 'NotAllowedError' || error?.name === 'AbortError') return
    throw error
  }

  try {
    const maybePromise = video.play()
    typeof maybePromise?.catch === 'function' && maybePromise.catch(handlePlayError)
  } catch (error) {
    handlePlayError(error)
  }
}

export default function useAutoplayHeroVideo({ id }) {
  const isMobile = useMobileBreakpoint()

  // iOS pauses autoplay videos on app/background switch —
  // this attempts to resume playback on return
  useEffect(() => {
    if (!isMobile) return

    function handleVisibilityChange() {
      const video = document.getElementById(id)
      if (video && document.visibilityState === 'visible') {
        setTimeout(() => {
          tryPlayVideo(video)
        }, 50)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [isMobile, id])
}
